import { Component, OnInit } from '@angular/core';
import { BaseModal } from 'src/app/core/utils/BaseModal';
import {LotService, ModalService} from 'src/app/core/services';
import { LotSteps, StatusLot } from 'src/app/core/models';

@Component({
  selector: 'app-processing-history',
  templateUrl: './lote-info.component.html',
  styleUrls: ['./lote-info.component.sass']
})
export class LoteInfoComponent extends BaseModal  implements OnInit {
  public violation: any = {};
  public lot: any = {};
  public loading: boolean;
  public sourcesById: { [param: string]: string } = {};
  public historiesByStep: any = {};
  public lotStepsI18n = [];
  public lotSteps = Object.values(LotSteps);
  public statusLot = Object.values(StatusLot);
  public statusLotI18n = [];

  constructor( public modalService: ModalService, public lotService: LotService ) {
    super(modalService);
  }
  get isValid(): boolean {
      throw new Error('Method not implemented.');
  }
  get lastState(): any {
      throw new Error('Method not implemented.');
  }
  onAllSubmited(): Promise<any> {
      throw new Error('Method not implemented.');
  }
  ngOnInit(): void {
    this.lotService.list({ contractId: this.initialState.contractId, 'id[in]': `[${this.initialState.lotId}]` }).then(res => {
      const lot = res?.result?.[0];
      if (lot) {
        this.lot = lot;
        if (this.lot.HistoryLots) {
          this.historiesByStep = this.lot.HistoryLots.reduce((acc, item) => {
            if (!acc[item.step]) {
              acc[item.step] = [];
            }
            const find = (acc[item.step].length > 0 && acc[item.step].find(i => i.status === item.status)) || false;
            if (!find) {
              acc[item.step].push(item);
            }
            return acc;
          }, {});
        }
      }
    }).finally(() => {
      this.loading = true;
    });
  }
  setLotStepsI18n(lotSteps) {
    this.lotStepsI18n = lotSteps;
  }
  setLotStatusI18n(statusLot) {
    this.statusLotI18n = statusLot;
  }

  getStatusLot(id) {
    if (this.statusLotI18n.length === 0) {
      return;
    }
    return this.statusLotI18n.find(s => s.id === id).value;
  }
}
